import { useUserProfileContext } from "@context/user_profile";
import { Navigate, Outlet } from "react-router";

interface Props {
    allowedRoles: string[]
}

export default function RoleRoute(props: Props) {
    const [isLoadingUserProfile, userInfo] = useUserProfileContext();
    if (isLoadingUserProfile) return <></>;

    if (userInfo && !props.allowedRoles.includes(userInfo.role || "")) return <Navigate to="/unauthorized" />

    return <Outlet />
}